/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

var i = 0;
dev_required = document.getElementsByClassName('dev_requis');
//console.log(dev_required);
for (i in dev_required){
    //console.log(dev_required[i].innerHTML);
    if (typeof dev_required[i].children !== "undefined") {
        if ((dev_required[i].innerHTML.replace(/\s+/g,'').length !== 0) && (dev_required[i].innerHTML.replace(/\s+/g,'') !== 'bool(false)')){
            dev_required[i].className += " dev_required";
        } else {
            dev_required[i].className += " dev_required_error";
        }
    }
}